import React from "react";

class IconClose extends React.Component {
    render() {
        return (
            <svg
                className="icon--close"
                viewBox="0 0 18 18"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <path
                        d="M15,12.6565657 C15,12.9090909 14.8989899,13.1616162 14.7171717,13.3434343 L13.3434343,14.7171717 C13.1616162,14.8989899 12.9090909,15 12.6565657,15 C12.4040404,15 12.1515152,14.8989899 11.969697,14.7171717 L9,11.7474747 L6.03030303,14.7171717 C5.84848485,14.8989899 5.5959596,15 5.34343434,15 C5.09090909,15 4.83838384,14.8989899 4.65656566,14.7171717 L3.28282828,13.3434343 C3.1010101,13.1616162 3,12.9090909 3,12.6565657 C3,12.4040404 3.1010101,12.1515152 3.28282828,11.969697 L6.25252525,9 L3.28282828,6.03030303 C3.1010101,5.84848485 3,5.5959596 3,5.34343434 C3,5.09090909 3.1010101,4.83838384 3.28282828,4.65656566 L4.65656566,3.28282828 C4.83838384,3.1010101 5.09090909,3 5.34343434,3 C5.5959596,3 5.84848485,3.1010101 6.03030303,3.28282828 L9,6.25252525 L11.969697,3.28282828 C12.1515152,3.1010101 12.4040404,3 12.6565657,3 C12.9090909,3 13.1616162,3.1010101 13.3434343,3.28282828 L14.7171717,4.65656566 C14.8989899,4.83838384 15,5.09090909 15,5.34343434 C15,5.5959596 14.8989899,5.84848485 14.7171717,6.03030303 L11.7474747,9 L14.7171717,11.969697 C14.8989899,12.1515152 15,12.4040404 15,12.6565657 Z"
                        fill="currentColor"
                    />
                </g>
            </svg>
        );
    }
}

export default IconClose;



// WEBPACK FOOTER //
// ./src/components/icons/IconClose.jsx